import type { SVGProps } from 'react';
const SvgFactCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fact_check_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM10 17H5v-2h5v2Zm0-4H5v-2h5v2Zm0-4H5V7h5v2Zm4.82 6L12 12.16l1.41-1.41 1.41 1.42L17.99 9l1.42 1.42L14.82 15Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fact_check_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFactCheck;
